import { Checkbox, FormControlLabel, TextField, Typography } from "@mui/material";
import moment from "moment";
import { useEffect, useState } from "react";
import ModalForm from "../Tools/ModalForm";
import { Euro } from "@mui/icons-material";


export default function EnrollmentCashing({ enrollment, onChange }){

    const [showForm, setShowForm] = useState(false);

    const [values, setValues] = useState({ cashedAt: '', amount: '' });

    useEffect(() => {
        setValues({
            cashedAt: moment(enrollment.cashedAt ?? undefined).format('YYYY-MM-DD'),
            amount: enrollment.amount.toString()
        });
    }, [enrollment]);

    const handleClick = () => {

        if(enrollment.cashedAt){

            const clearConfirm = window.confirm("Êtes vous sûr de vouloir effacer cette date ?");

            return clearConfirm ? onChange({ ...enrollment, cashedAt: null }) : false;
        }

        setShowForm(true);
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        const newEnrollment = { ...enrollment, 
            cashedAt: moment(values.cashedAt).format('YYYY-MM-DD HH:mm:ss'),
            amount: parseFloat(values.amount.replaceAll(',','.').trim())  
        }
        onChange(newEnrollment);
        setShowForm(false);
    }

    return (<>

        <FormControlLabel
            label={
                <Typography variant="body2" color="text.secondary">
                    {enrollment.cashedAt ? moment(enrollment.cashedAt).format('DD/MM/YYYY') : ''}
                </Typography>
            }
            control={
                <Checkbox 
                    size="small"
                    checked={!!enrollment.cashedAt ? true : false}
                    onChange={handleClick}
                />
            }
        />

        <ModalForm open={showForm} onSubmit={handleSubmit} onClose={() => setShowForm(false)} title='Encaissement'>
        
            <TextField
                label="Encaissée le"
                value={values.cashedAt || ''}
                onChange={e => setValues({ ...values, cashedAt: e.target.value })}
                required={true}
                size="small"
                type="date"
            />

            <TextField
                label="Montant encaissé"
                value={values.amount || ''}
                onChange={e => setValues({ ...values, amount: e.target.value })}
                required={true}
                size="small"
                type="number"
                InputProps={{
                    inputProps: {min: 0, step: 0.01},
                    endAdornment: <Euro color='action'/>
                }}
            />
        
        
        </ModalForm>
    </>)
}